import { InertiaApp } from '@inertiajs/inertia-vue';
import Vue from 'vue';
import AOS from "aos";
import VueGlide from 'vue-glide-js'

Vue.use(VueGlide)

Vue.use(InertiaApp);

Vue.mixin({
    methods: {
        route: (...args) => window.route(...args),
        updatePageTitle() {
            document.title = this.$page.meta.title ? `${this.$page.meta.title} | ${this.$page.app.name}` : this.$page.app.name
        },
    }
});

const app = document.getElementById('app');

const instance = new Vue({
    render: h => h(InertiaApp, {
        props: {
            initialPage: JSON.parse(app.dataset.page),
            resolveComponent: name => {
                return import(`@/Pages/${name}`).then(module => {
                    if (name === 'Index' && !instance.checked) {
                        instance.inSite = true;
                    }
                    instance.checked = true;
                    return module.default;
                });
            }
        }
    }),
    created() {
        AOS.init();
    },
    data: {
        inSite: false,
        checked: false,
    },
}).$mount(app)
